// Copyright (C) AirWorks Solutions, Inc - All Rights Reserved
// DO NOT REDISTRIBUTE
// UNAUTHORIZED COPYING OF THIS FILE, ANY PART OR WHOLE, VIA ANY MEDIUM IS STRICTLY PROHIBITED
// PROPRIETARY AND CONFIDENTIAL

const styles = (theme: any) => ({
  // Inline, so the editor sits in a details row or a card footer line without reflowing it.
  root: {
    display: 'inline-flex',
    alignItems: 'center',
    gap: theme.spacing(0.5),
    minWidth: 0,
    maxWidth: '100%',
    // The host's font: the value reads like the row it lives in.
    fontSize: 'inherit',
    lineHeight: 'inherit',
    color: 'inherit',
  },
  value: {
    fontSize: 'inherit',
    lineHeight: 'inherit',
    color: 'inherit',
    minWidth: 0,
    overflow: 'hidden',
    textOverflow: 'ellipsis',
    whiteSpace: 'nowrap',
  },
  empty: {
    color: theme.palette.text.secondary,
    fontStyle: 'italic',
    // Italic glyphs overhang their box to the right; without this the value's overflow
    // clipping (there to ellipsize long IDs) shaves the last letter off the placeholder.
    paddingRight: '0.25em',
  },
  addPrompt: {
    cursor: 'pointer',
  },
  iconButton: {
    padding: '2px',
    fontSize: '1em',
  },
  input: {
    fontSize: 'inherit',
    lineHeight: 'inherit',
    '& .MuiInputBase-input': {
      padding: '2px 6px',
      background: '#E6E8ED',
      borderRadius: '4px',
      fontSize: 'inherit',
      minWidth: '10em',
    },
  },
  error: {
    color: theme.palette.error.main,
    fontSize: '12px',
    lineHeight: 1.2,
    whiteSpace: 'normal',
  },
});

export default styles;
